var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "addAgent",
    attrs: {
      id: "add-agent-modal",
      "modal-dialog-size": "xs",
      "loaders-disabled": "",
      "modal-dialog-scrollable": false,
    },
    on: { show: _vm.handleShow, hidden: _vm.resetData },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_vm._v("\n    " + _vm._s(_vm.$t("agents.addAgent")) + "\n  ")]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", { staticClass: "justified" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("agents.messages.addAgent")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "align-items-center justify-content-start" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c("material-input", {
                      attrs: {
                        "validator-context": _vm.$v,
                        label: _vm.$t("account.givenName"),
                        "required-indicator": "",
                      },
                      model: {
                        value: _vm.givenName,
                        callback: function ($$v) {
                          _vm.givenName = $$v
                        },
                        expression: "givenName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c("material-input", {
                      attrs: {
                        "validator-context": _vm.$v,
                        label: _vm.$t("account.familyName"),
                        "required-indicator": "",
                      },
                      model: {
                        value: _vm.familyName,
                        callback: function ($$v) {
                          _vm.familyName = $$v
                        },
                        expression: "familyName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "material-input",
                      {
                        staticClass: "placeholder-danger",
                        attrs: {
                          "validator-context": _vm.$v,
                          "required-indicator": "",
                        },
                        model: {
                          value: _vm.userType,
                          callback: function ($$v) {
                            _vm.userType = $$v
                          },
                          expression: "userType",
                        },
                      },
                      [
                        _c("select2", {
                          attrs: {
                            name: "userType",
                            data: _vm.userTypes,
                            options: {
                              placeholder: _vm.$t("account.userType") + " *",
                            },
                            required: "",
                          },
                          on: {
                            change: function (val) {
                              return (_vm.userType = val)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "material-input",
                      {
                        attrs: {
                          "validator-context": _vm.$v,
                          label: _vm.$t("account.phoneNumber"),
                          "required-indicator": "",
                        },
                        model: {
                          value: _vm.phoneNumber,
                          callback: function ($$v) {
                            _vm.phoneNumber = $$v
                          },
                          expression: "phoneNumber",
                        },
                      },
                      [
                        _c("phone-input", {
                          staticClass: "material-input form-control form",
                          class: { "form-control-filled": _vm.phoneNumber },
                          attrs: {
                            name: "phoneNoFill",
                            title: _vm.$t("account.form.validPhoneNumber"),
                            type: "text",
                            "data-lpignore": "true",
                            "emit-value": "",
                            value: _vm.phoneNumber,
                          },
                          on: {
                            change: function (val) {
                              return (_vm.phoneNumber = val)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "6" } },
                  [
                    _c(
                      "material-input",
                      {
                        attrs: { "validator-context": _vm.$v },
                        model: {
                          value: _vm.userLanguage,
                          callback: function ($$v) {
                            _vm.userLanguage = $$v
                          },
                          expression: "userLanguage",
                        },
                      },
                      [
                        _c("select2", {
                          attrs: {
                            name: "userLanguage",
                            data: _vm.userLanguages,
                            options: {
                              placeholder: "" + _vm.$t("account.language"),
                            },
                            value: _vm.userLanguage
                              ? _vm.userLanguage.id
                              : _vm.portalLocale,
                            required: "",
                          },
                          on: {
                            change: function (val) {
                              return (_vm.userLanguage = val)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("material-input", {
                      attrs: {
                        "validator-context": _vm.$v,
                        label: _vm.$t("account.email"),
                        "required-indicator": "",
                        type: "email",
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", {
              attrs: {
                text: _vm.$t("agents.addAgent"),
                disabled: !_vm.canSubmit,
                loading: _vm.loading,
                "loading-succeeded": _vm.loadingSucceeded,
              },
              on: { finish: _vm.closeModal, click: _vm.handleSubmit },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }